export default __webpack_public_path__ + "static/media/2122.612479ad.png";